if (!window.Eurus.loadedScript.includes('cart-attribute.js')) {
  window.Eurus.loadedScript.push('cart-attribute.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartAttribute', () => ({
        agechecked: false,
        dispatch_date: '',
        loadDataOver18() {
          this.agechecked = localStorage.cart_over_18_agree == 'agreed' ? true : false;
          this.$watch('agechecked', () => {
            var status = this.agechecked ? 'agreed' : 'not agreed';
            this.save('Over 18',status);
            localStorage.cart_over_18_agree = status;
          });
        },
        loadDataDispatchDate() {
          var status = localStorage.cart_dispatch_date ? localStorage.cart_dispatch_date : 'none';
          this.save('DispatchDate', status);
          if (status != "none") this.dispatch_date = status;
          document.querySelector("#DispatchDate").onchange = () => {
            var status = document.querySelector("#DispatchDate").value;
            if (status != "") {
              this.save('DispatchDate', status);
            } else {
              this.save('DispatchDate', 'none');
            }
            localStorage.cart_dispatch_date = status;
          };
        },
        save(label, attributes) {
          clearTimeout(this.t);
          var attributes_update = { attributes: {} }
          attributes_update.attributes[label] = attributes;
          const func = () => {
            Alpine.store('xCartHelper').updateCart(attributes_update);
          } 
          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });
};